import { FC } from "react";

import { mergeStyles, TextBadge } from "@bps/fluent-ui";

import { ClaimStatusBadgeProps } from "./ClaimStatusBadge.types.ts";
import { wrapBadge } from "./utils.tsx";

export const ClaimStatusStandardBadge: FC<ClaimStatusBadgeProps> = props => {
  const badgeStyles = mergeStyles(
    {
      width: 130,
      padding: "6px 11px",
      display: "block",
      overflow: "hidden"
    },
    props.styles?.badge
  );

  return wrapBadge(
    <TextBadge
      badgeColor={props.badgeColor}
      badgeSize={props.badgeSize}
      hasBorder={props.hasBorder}
      styles={{ root: badgeStyles }}
    >
      {props.text}
    </TextBadge>,
    props.styles?.root
  );
};
